import React from "react";
import "./ourService.css";
import ServiceImg from "../../Assets/home.jpeg";
import carServiceImg from "../../Assets/carServiceImg3.jpg";
const ourService = () => {
  const scrollToContact = () => {
    // Scroll to the Footer Contact section
    const footerContact = document.getElementById("Contact");
    footerContact.scrollIntoView({ behavior: "smooth" });

    // if (click) {
    //   carSection.style.opacity = "1";
    // }
  };

  return (
    <div>
      {/* Our Services */}
      <main>
        <div className="album py-5  ourServiceContainer" id="ourService">
          <h1 className="headingServices text-center py-2">Our Services</h1>
          {/* All the cards Are inside this section */}
          <div className="container g-3 OurService ">
            {/* This is the Left side Card */}
            <div className="card sideCard card1 ">
              <div className="card-body">
                <h5 className="card-title ">Door-to-Door Repair Service</h5>
                <p className="card-text">
                  Experience easy windshield repair with our door-to-door
                  service. Simply give us a call, and our dedicated team will
                  arrive at your specified location to collect your vehicle.
                  We'll transport it to our garage for expert repair. Once the
                  repair is completed, we'll ensure your vehicle is safely
                  returned to you, right at your doorstep. Your convenience is
                  our priority – trust us to get you back on the road.
                </p>

                <button
                  href="#"
                  className="btn btn-warning"
                  onClick={scrollToContact}
                >
                  Go somewhere
                </button>
              </div>
            </div>
            {/* This is the right side cards */}
            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-2 g-3 cardRow">
              <div className="col " data-aos="fade-right">
                <div className="card card1 shadow-sm">
                  <div className="card-body ">
                    <h4 className="card-title">Expert Windshield Fix</h4>
                    <p className="card-text">
                      Got a chip or crack in your windshield? No worries! Our
                      skilled team can fix it up, stopping the damage from
                      getting worse. We're here to make sure your view stays
                      clear without breaking the bank. Your safety matters, and
                      we've got your windshield covered.
                    </p>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="btn-group">
                        <button
                          type="button"
                          className="btn btn-sm btn-warning"
                          onClick={scrollToContact}
                        >
                          Contact us
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col" data-aos="fade-right">
                <div className="card card1 shadow-sm">
                  <div className="card-body">
                    <h4 className="card-title">Windshield Replacement</h4>
                    <p className="card-text">
                      Experience the ClearVue difference with our windshield
                      replacement service. When chips and cracks become too
                      much, our skilled technicians provide a fresh start with a
                      quality replacement. We prioritize safety, ensuring your
                      new windshield is both secure and clear for a brighter
                      journey ahead.
                    </p>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="btn-group">
                        <button
                          type="button"
                          className="btn btn-sm btn-warning"
                          onClick={scrollToContact}
                        >
                          Contact us
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col" data-aos="fade-right">
                <div className="card card1 shadow-sm">
                  <div className="card-body">
                    <h4 className="card-title">
                      Side & Rear Window Repair/Replacement
                    </h4>

                    <p className="card-text">
                      Damage to your side or rear windows can be just as
                      important to repair as damage to your windshield. We can
                      repair or replace your damaged windows as quickly as
                      possible.
                    </p>

                    <div className="d-flex justify-content-between align-items-center">
                      <div className="btn-group">
                        <button
                          type="button"
                          className="btn btn-sm btn-warning"
                          onClick={scrollToContact}
                        >
                          Contact us
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col" data-aos="fade-right">
                <div className="card  card1 shadow-sm">
                  <div className="card-body">
                    <h4 className="card-title">Heavy-Duty Window Solutions</h4>
                    <p className="card-text">
                      Trucks need clear views too! Our Truck Window Fix &
                      Replace service is here to quickly repair or replace
                      damaged side and rear windows. Whether your truck is your
                      workplace or adventure companion, count on us to keep its
                      windows in top-notch condition for the road ahead. Your
                      truck, our care!
                    </p>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="btn-group">
                        <button
                          type="button"
                          className="btn btn-sm btn-warning"
                          onClick={scrollToContact}
                        >
                          Contact us
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ourService;
